import ContactRootPage from './contact-root-page';

export default ContactRootPage;
